//imports
import React, { Fragment, useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Loading } from 'Components';
import { LogManagerConsole } from 'Core/logManager';

import { reset, getAllPreferences, savePreference } from './redux/slice'

//component
const PreferencesContainer = forwardRef((props, ref) => {

	const dispatch = useDispatch()
	const { preferencesCompany, preferencesUser, preferencesOther, result, resultUpdate, hasFetchedAll } = useSelector(state => state.preferencesRedux);
	const { authenticatedId, user } = useSelector(state => state.securityRedux);
	const [loadPage, setLoadPage] = useState(false)

	const applyPreferences = () => {
		setLoadPage(true)

		LogManagerConsole('PREFERENCES', 'useEffect', result, preferencesUser, props.preferencesKey)

		let preferencesKeyTemp = preferencesUser.find(x => x.preferenceKey === props.preferencesKey)
		let preferencesUserJSON = preferencesKeyTemp && preferencesKeyTemp.preferenceValue != "" && preferencesKeyTemp.preferenceValue || "{}"
		preferencesUserJSON = JSON.parse(preferencesUserJSON)

		preferencesKeyTemp = preferencesCompany.find(x => x.preferenceKey === props.preferencesKey)
		let preferencesCompanyJSON = preferencesKeyTemp && preferencesKeyTemp.preferenceValue != "" && preferencesKeyTemp.preferenceValue || "{}"
		preferencesCompanyJSON = JSON.parse(preferencesCompanyJSON)

		if (props.onInitialPreferences) props.onInitialPreferences(preferencesUserJSON, preferencesCompanyJSON);
	}

	useEffect(() => {
		// SGSD-8636: if another <Preferences> instance mounted elsewhere (or another
		// tab, already unmounted) already triggered and resolved the global fetch before
		// this mount, `hasFetchedAll` is already true and the `result:true` that
		// announced it was already consumed and reset by that other instance — waiting
		// for `result` to flip back to true below here would never happen, leaving this
		// instance stuck showing the loading state forever. In that case we apply the
		// already-available preferences right away instead of requesting them again. If
		// `result`/`resultUpdate` are still true (nobody consumed them yet), we do
		// nothing here: the effect below will already run on this same mount and handle
		// it, so we don't apply twice.
		if (hasFetchedAll && !result && !resultUpdate) {
			applyPreferences()
		} else if (!hasFetchedAll) {
			dispatch(getAllPreferences({ authenticatedId, companyId: user?.companyId }))
		}
	}, [])

	useEffect(() => {
		if (result || resultUpdate) {
			dispatch(reset({ result: false, resultUpdate: false }))
			applyPreferences()
		}

		/* if (resultUpdate) {
			dispatch(reset({ resultUpdate: false }))
		} */
	}, [result, resultUpdate])

	useImperativeHandle(ref, () => ({
		getPreferences: (entity, key) => {

			let preferencesKeyTemp
			let preferencesJSON

			switch (entity) {
				case "User":
					preferencesKeyTemp = preferencesUser.find(x => x.preferenceKey === key)
					preferencesJSON = preferencesKeyTemp && preferencesKeyTemp.preferenceValue != "" && preferencesKeyTemp.preferenceValue || "{}"
					preferencesJSON = JSON.parse(preferencesJSON)
					return preferencesJSON

				case "Company":
					preferencesKeyTemp = preferencesCompany.find(x => x.preferenceKey === key)
					preferencesJSON = preferencesKeyTemp && preferencesKeyTemp.preferenceValue != "" && preferencesKeyTemp.preferenceValue || "{}"
					preferencesJSON = JSON.parse(preferencesJSON)
					return preferencesJSON

				case "Other":
					preferencesKeyTemp = preferencesOther.find(x => x.preferenceKey === key)
					preferencesJSON = preferencesKeyTemp && preferencesKeyTemp.preferenceValue != "" && preferencesKeyTemp.preferenceValue || "{}"
					preferencesJSON = JSON.parse(preferencesJSON)
					return preferencesJSON

			}
		},
		savePreference: (entity, key, preference) => {
			//dispatch(updatePreferenceView(true))
			switch (entity) {
				case "User":
					dispatch(savePreference({ entityName: "User", entityId: authenticatedId, preferenceKey: key, preferenceValue: preference }))
					break;
				case "Company":
					dispatch(savePreference({ entityName: "Company", entityId: user.companyId, preferenceKey: key, preferenceValue: preference }))
					break;
				case "Other":
					dispatch(savePreference({ entityName: "Other", entityId: authenticatedId, preferenceKey: key, preferenceValue: preference }))
					break;
			}
		}
	}));

	return (
		<Fragment>
			{
				!loadPage
					? <Loading full />
					: props.children
			}
		</Fragment>
	);

})

//Export Component
export default PreferencesContainer